import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';

const About = () => {
    return (
        <div className="about-page">
            <div className="about-content">
                <div className="about-contents">
                    <h1 className="mission-header">Our Team</h1>
                    <p className="mission-subtitle">We are a diverse team of university students from IT, Data Science,
                        Cybersecurity, and Business Information Systems. Despite our different academic backgrounds,
                        we share a common goal: solving real-world challenges faced by those affected by climate change.
                        Through technology, research, and user-friendly design, we aim to help Australian gardeners
                        make their gardens thrive, no matter the conditions.
                    </p>
                    <h1 className="team-header">Our Mission</h1>
                    <p className="team-subtitle">Our mission is to support Australian gardeners in navigating the
                        unpredictable effects of climate change. As environmental conditions shift year by year,
                        traditional planting knowledge has become unreliable — fruits fail to ripen, flowers no longer bloom on time,
                        and once-thriving gardens now struggle to survive.
                    </p>
                    <p>
                        Some gardens are being ruined by unexpected heatwaves, heavy rain, or unseasonal frosts. We aim to alert
                        gardeners ahead of time, giving them the opportunity to protect and prepare their gardens before the weather
                        takes a toll.
                    </p>
                    <p>
                        By analysing real-time climate data, we provide tailored guidance on which plants are suitable to grow in
                        current conditions. Through this, we hope to empower gardeners to adapt, take action, and ultimately bring
                        their gardens back to life - one flourishing plant at a time.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;